import { render, staticRenderFns } from "./GaleriaProductFileComponent.vue?vue&type=template&id=f3d55e5a&scoped=true"
import script from "./GaleriaProductFileComponent.vue?vue&type=script&lang=js"
export * from "./GaleriaProductFileComponent.vue?vue&type=script&lang=js"
import style0 from "./GaleriaProductFileComponent.vue?vue&type=style&index=0&id=f3d55e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d55e5a",
  null
  
)

export default component.exports